import React, { useState, useEffect } from 'react';
import utils from '@/utils/utils';
import dd from '@/utils/dd';
import { base } from '@/services/api/_base';
import "./style.scss";

function DefaultGoodsList(props: any) {
  const {
    keys,
    mark,
    list,
    compId,
    pId,
    mallTest,
    _pvMoudel,
    _adMoudel,
  } = props;
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [notMore, setNotMore] = useState<boolean>(false);
  const [carImgH, setCarImgH] = useState<any>("auto");

  // 商品查看更多
  const lookMore = () => {
    let count: number =
      list.length % 6 === 0
        ? list.length / 6
        : parseInt((list.length / 6).toString()) + 1;
    if (currentPage + 1 === count) {
      setNotMore(() => true);
    } else {
      setCurrentPage(() => currentPage + 1);
    }
    // 特卖商品查看更多点击埋点
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      compId,
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      keys === "MR"
        ? "ec_topic_mall_mrshangpin_more_click"
        : "ec_topic_mall_zdyshangpin_more_click",
      dd.baseParams,
      extendParams
    );
  };

  // 三个点击的跳转及埋点
  const clickTMGoods = (data: any, positionId: number) => {
    const sourceid = keys === "TM" ? 200004 : keys === "MR" ? 200005 : 200006;
    window.location.href = base.isProduct
      ? `https://mcar.mall.autohome.com.cn/frontEndPageStatic/productDetail/index.html?itemId=${data.biz_id}&sourceid=${sourceid}&test=2021&mallTest=${mallTest}${_pvMoudel}${_adMoudel}`
      : `http://leads2.terra.autohome.com.cn/frontEndPageStatic/productDetail/index.html?itemId=${data.biz_id}&sourceid=${sourceid}&test=20211230&mallTest=${mallTest}${_pvMoudel}${_adMoudel}`;
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      brandId: data.cms_brand_ids,
      compId,
      positionId,
      goodId: data.biz_id,
      mallTest,
    };
    // 点击埋点除了组件id其他全部传
    keys === "goods" && delete extendParams["compId"];
    const eventId =
      keys === "TM"
        ? "ec_topic_mall_zdyshangpin_click"
        : keys === "MR"
        ? "ec_topic_mall_mrshangpin_click"
        : "ec_topic_mall_liebiao_shangpin_click";
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger("click", eventId, dd.baseParams, extendParams);
  };

  useEffect(() => {
    // 自定义商品列表
    if (keys === "TM" && list.length > 0 && mark.pageType === "mall") {
      list
        .slice((currentPage - 1) * 6, currentPage * 6)
        .forEach((v: any, k: number) => {
          // 曝光埋点
          let extendParams = {
            ...dd.ep,
            providerId: pId,
            brandId: v.data.cms_brand_ids,
            compId,
            positionId: k + 1,
            goodId: v.id,
            mallTest,
          };
          extendParams = utils.formatParams(extendParams);
          utils.pvTrackLogger(
            "show",
            "ec_topic_mall_zdyshangpin_show",
            dd.baseParams,
            extendParams
          );
        });
      // 查看更多按钮曝光埋点
      let extendParams = {
        ...dd.ep,
        providerId: pId,
        compId,
        mallTest,
      };
      extendParams = utils.formatParams(extendParams);
      utils.pvTrackLogger(
        "show",
        "ec_topic_mall_zdyshangpin_more_show",
        dd.baseParams,
        extendParams
      );
    }
    // 默认商品列表
    if (keys === "MR" && list.length > 0 && mark.pageType === "mall") {
      list.slice(0, 6).forEach((v: any, k: number) => {
        // 曝光埋点
        let extendParams = {
          ...dd.ep,
          providerId: pId,
          brandId: v.data.cms_brand_ids,
          compId,
          positionId: k + 1,
          goodId: v.id,
          mallTest,
        };
        extendParams = utils.formatParams(extendParams);
        utils.pvTrackLogger(
          "show",
          "ec_topic_mall_mrshangpin_show",
          dd.baseParams,
          extendParams
        );
      });
      // 查看更多按钮曝光埋点
      let extendParams = {
        ...dd.ep,
        providerId: pId,
        compId,
        mallTest,
      };
      extendParams = utils.formatParams(extendParams);
      utils.pvTrackLogger(
        "show",
        "ec_topic_mall_mrshangpin_more_show",
        dd.baseParams,
        extendParams
      );
    }
    // 商品页面
    if (keys === "goods" && list.length > 0 && mark.pageType === "item") {
      list.forEach((v: any, k: number) => {
        // 曝光埋点
        let extendParams = {
          ...dd.ep,
          providerId: pId,
          brandId: v.data.cms_brand_ids,
          positionId: k + 1,
          goodId: v.id,
          mallTest,
        };

        extendParams = utils.formatParams(extendParams);
        utils.pvTrackLogger(
          "show",
          "ec_topic_mall_liebiao_shangpin_show",
          dd.baseParams,
          extendParams
        );
      });
    }
  }, [list, JSON.stringify(mark)]);

  useEffect(() => {
    // @ts-ignore
    const carImgH = document.getElementById("carImg_MR")?.offsetWidth * 0.75;
    if (carImgH > 0) {
      setCarImgH(() => carImgH);
    }
    // @ts-ignore
  }, [document.getElementById("carImg_MR")?.offsetWidth]);

  return (
    <div
      style={{
        overflowY: keys === "goods" ? "scroll" : "inherit",
        height: keys === "goods" && list.length > 2 ? "calc(100% - 37px)" : "",
      }}
    >
      <div key={keys} className="defaultGoodsList">
        {(keys === "goods" ? list : list.slice(0, currentPage * 6)).map(
          (v: any, k: number) => {
            const { data } = v;
            const { commodity_type, sale_price, worth } = data;
            return (
              <span
                key={v.id}
                className="item-goods"
                onClick={() => clickTMGoods(data, k + 1)}
              >
                <span className="carInfo">
                  <img
                    alt=''
                    id="carImg_MR"
                    src={data.img_url}
                    style={{ height: carImgH }}
                  />
                  <span>{`${data.title}`}</span>
                </span>
                <span className="youhui">
                  {commodity_type && Number(commodity_type) === 2
                    ? worth > 0
                      ? sale_price
                        ? `${sale_price || ""}元抵${worth || 0}元权益`
                        : `抵${worth || 0}元权益`
                      : `支付${sale_price}元`
                    : `${sale_price}元`}
                </span>
                <span className="btn">立即抢购</span>
              </span>
            );
          }
        )}
      </div>

      <div
        className="more"
        onClick={() => setCurrentPage(() => currentPage + 1)}
      >
        {keys !== "goods" && !notMore && list.length > 6 ? (
          <div className="more-button" onClick={() => lookMore()}>
            <span className="more-text">查看更多商品</span>
            <i className="more-icon"></i>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default DefaultGoodsList;
